import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { customerCardStyles } from "@insite/content-library/Components/CustomerCard";
import { GridItemStyle } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cardContainerStyles.cardDivider = {
    css: css`
        width: calc(100% - 20px);
        margin: 0 10px;
    `,
};
cardContainerStyles.gridItem = {
    width: 12,
    css: css`
        padding: 10px 1.6rem;
    `,
};
customerCardStyles.selectButton = { variant: "primary" };
